import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import Search from '@/components/SearchV3/index.vue';
import OrderAction from './orderAction.vue';
import { getTagList } from '@/api/common/index.js';
import { repositoryName, cat1Options, cat2Options, cat1OptionsParticle } from '@/views/repository/config';
import { filterOption } from '@/utils/option';
import LanguageSelector from '@/components/LanguageSelector/index.vue';

export default {
  components: {
    Search: Search,
    OrderAction: OrderAction
  },

  props: {
    query: {
      type: Object,
      required: true
    },

    handleSearch: {
      type: Function,
      required: true
    },

    handleResetSearch: {
      type: Function,
      required: true
    },

    keyField: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    formItems: {
      type: Array,
      default: null
    },

    resourceType: {
      type: Number,
      default: 0
    },
    /**
     * 对组件中的radio选择项做过滤
     */
    optionsFilter: {
      type: Object,
      default: function _default() {}
    },
    /**
     * 传参formItemParams
     */
    formItemParams: {
      type: Object,
      default: function _default() {}
    }
  },

  data: function data() {
    // 通过父级传入search_field配置项
    return {
      keyFieldConfig: this.keyField.length > 0 ? this.keyField : [],
      tagList: {}
    };
  },


  computed: {
    libName: function libName() {
      var _this = this;

      return (repositoryName.find(function (e) {
        return e.value === _this.resourceType;
      }) || {}).label;
    },

    // 根据 formItems 过滤表单项
    formItemList: function formItemList() {
      var _this2 = this;

      return [{
        prop: 'search_field',
        type: 'select',
        params: _extends({
          clearable: false,
          filterable: true,
          style: 'width: 220px;',
          options: this.keyFieldConfig,
          placeholder: '请选择搜索类型'
        }, this.formItemParams && this.formItemParams.search_field || {})
      }, {
        prop: 'name',
        type: 'input',
        params: function params(_ref) {
          var formValue = _ref.formValue;

          return _extends({
            disabled: false,
            readonly: false,
            clearable: true,
            style: 'width: 220px;',
            placeholder: '请选择' + _this2.libName + '名称'
          }, _this2.formItemParams && _this2.formItemParams.keyword || {});
        }
      }, {
        prop: 'languages',
        type: 'component',
        component: LanguageSelector
      }, {
        prop: 'keyword',
        type: 'input',
        params: function params(_ref2) {
          var formValue = _ref2.formValue;

          return _extends({
            disabled: false,
            readonly: false,
            clearable: true,
            style: 'width: 220px;',
            placeholder: formValue.search_field ? '按' + _this2.keyFieldConfig.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入关键字'
          }, _this2.formItemParams && _this2.formItemParams.keyword || {});
        }
      }, {
        prop: 'cat2_ids',
        type: 'select',
        params: _extends({
          clearable: false,
          filterable: true,
          multiple: true,
          style: 'width: 220px;',
          options: this.filteredCat2Options,
          collapseTags: true,
          class: 'search-filter-select',
          placeholder: '请选择实现方式'
        }, this.formItemParams && this.formItemParams.cat2_ids || {})
      }, {
        prop: 'cat1_ids',
        type: 'select',
        params: _extends({
          clearable: false,
          filterable: true,
          multiple: true,
          style: 'width: 220px;',
          options: this.filteredCat1Options,
          collapseTags: true,
          class: 'search-filter-select',
          placeholder: '请选择类型'
        }, this.formItemParams && this.formItemParams.cat1_ids || {})
      }, {
        prop: 'tag_ids',
        type: 'business',
        subtype: 'tag-cascader-multi',
        params: _extends({
          clearable: false,
          filterable: true,
          multiple: true,
          style: 'width: 400px;',
          placeholder: '请选择' + this.libName + '标签',
          collapseTags: true,
          class: 'search-filter-select',
          params: {
            type: this.resourceType
          }
        }, this.formItemParams && this.formItemParams.tag_ids || {})
      }, {
        prop: 'access_allow_pt',
        type: 'select',
        params: {
          placeholder: '请选择是否对外展示',
          clearable: true,
          options: [{
            label: 'ON',
            value: 1
          }, {
            label: 'OFF',
            value: 2
          }]
        }

      }];
    },
    innerFormList: function innerFormList() {
      var _this3 = this;

      var tempConfig = [];
      this.formItems.forEach(function (props) {
        var formItem = _this3.formItemList.find(function (item) {
          return item.prop === props;
        });
        if (formItem) {
          tempConfig.push(formItem);
        }
      });
      return tempConfig;
    },
    filteredCat1Options: function filteredCat1Options() {
      var _this4 = this;

      if (this.resourceType === 10) {
        return cat1OptionsParticle;
      }
      return filterOption({
        list: cat1Options.filter(function (e) {
          if (Number(_this4.resourceType) === 10) {
            return e.value !== 3;
          }
          return true;
        }),
        condition: this.optionsFilter && this.optionsFilter.cat1_ids
      });
    },
    filteredCat2Options: function filteredCat2Options() {
      return filterOption({
        list: cat2Options,
        condition: this.optionsFilter && this.optionsFilter.cat2_ids
      });
    }
  },

  methods: {
    getAudioTag: function getAudioTag() {
      this.getOptions(11);
      this.getOptions(12);
    },
    getOptions: function getOptions(type) {
      var _this5 = this;

      getTagList({
        type: type
      }).then(function (res) {
        // self.bStyleLoading = false
        _this5.tagList[type === 12 ? 1 : 2] = (_.get(res, 'data.data.tags') || []).map(function (e) {
          e.label = e.name;
          e.value = Number(e.id);
          return e;
        });
      }).catch(function () {});
    }
  },

  mounted: function mounted() {
    if (this.formItems.indexOf('tag1_id') !== -1) {
      this.getAudioTag();
    }
  }
};